export enum SortDirection {
    None = 0,
    Ascending = 1,
    Descending = 2
}


// WEBPACK FOOTER //
// ./src/app/components/Grid/sortDirection.enum.ts